/* eslint-disable @typescript-eslint/no-namespace */
import axios, { AxiosInstance } from "axios";

// Define environment variable type
declare global {
  namespace NodeJS {
    interface ProcessEnv {
      REACT_APP_API_URL: string;
    }
  }
}

const API_URL: string = process.env.REACT_APP_API_URL;

// production server
export const api: AxiosInstance = axios.create({
  baseURL: API_URL,
});

export const apiUrl: string = API_URL;

// aws s3 bucket configurations
export const awsRegion: string = "eu-central-1";
export const awsIdentityPoolId: string =
  "eu-central-1:949b9487-ed35-4eb3-a2d3-1866e6ad890b";
export const awsBucket: string = "avangrat-development";
